import { render, staticRenderFns } from "./dateColor.vue?vue&type=template&id=6f9d281f&"
import script from "./dateColor.vue?vue&type=script&lang=js&"
export * from "./dateColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports